

import React from "react";
import box1 from "../../assests/grup1.png";
import box2 from "../../assests/grup2.png";
import box3 from "../../assests/grup3.png";
import box4 from "../../assests/GroupBlue.png";


const Boxvalue = ({ metrics = [] }) => {
  const icons = [box4,box1, box3,box2];

  return (
    <div className="grid grid-cols-2 gap-6 items-stretch">
      {metrics.map((m, i) => (
        <div
          key={i}
          className="bg-[#F0EFFF] rounded-xl shadow-md p-5 flex justify-between items-center gap-4 h-full"
        >
          {/* Left side */}
          <div className="flex-1 pr-4">
            <h2 className="text-[40px] font-semibold text-black">{m.value}</h2>
            <p className="text-black font-normal text-[16px] mt-1 break-words">
              {m.title}
            </p>
          </div>

          {/* Right side */}
          <div className="w-20 h-20 flex items-center justify-center rounded-lg">
            <img
              src={icons[i % icons.length]}
              alt="metric icon"
              className="w-full h-full object-contain"
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default Boxvalue;


